import { getTvObject, tv } from '@costar-ui/cosmos';

var badgeTV = getTvObject({
  slots: {
    badge: 'rounded-lg p-1',
    text: 'font-normal'
  },
  variants: {
    variant: {
      primary: {
        badge: 'bg-status-info',
        text: 'text-on-status-info'
      },
      'primary-inverse': {
        badge: 'bg-base',
        text: 'text-status-info'
      },
      'primary-inverse-outline': {
        badge: 'border border-status-info bg-base',
        text: 'text-status-info'
      },
      neutral: {
        badge: 'border border-action-neutral bg-action-neutral',
        text: 'text-on-status-info'
      },
      alert: {
        badge: 'bg-accent-emphasize',
        text: 'text-on-accent-emphasize'
      }
    },
    size: {
      std: {
        badge: 'h-4 min-w-4',
        text: 'text-p-14'
      },
      sm: {
        badge: 'h-3.5 min-w-3.5',
        text: 'text-p-12 '
      }
    }
  }
});
var badgeStyles = tv(badgeTV);

export { badgeStyles, badgeTV };
//# sourceMappingURL=badge.styles.esm.js.map
